import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextInput from '../InputText';
import * as Styled from './styles';
import Button from '../Button';
import { TextP } from '../Text';
import { colours, fonts } from '../../styles/theme';

type SearchBarProps = {
  handleSearch: (searchValue?: string) => void;
  searchCount: number;
  total: number;
  setSearchValue: (serachValue: string) => void;
  searchValue: string;
  placeholder?: string;
  handleEnter?: () => void;
  onClick?: () => void;
  autoComplete?: string;
};

const SearchBar = ({
  handleSearch,
  searchCount,
  total,
  setSearchValue,
  searchValue,
  placeholder,
  handleEnter,
  onClick,
  autoComplete,
}: SearchBarProps) => (
  <Styled.SearchBarStyled>
    <FontAwesomeIcon icon="magnifying-glass" color={colours.colour15} />
    <TextInput
      handleHandle={(value: string) => setSearchValue(value)}
      inputValue={searchValue}
      id="searchInput"
      keyName=""
      handleEnter={handleEnter || (() => handleSearch(searchValue.toLowerCase()))}
      placeholder={placeholder || ''}
      autoComplete={autoComplete || 'on'}
    />
    <Button onClick={onClick || (() => handleSearch(searchValue.toLowerCase()))} theme="tertiary">
      <TextP>Search</TextP>
    </Button>
    {searchCount !== total && (
      <Styled.TextWrapper>
        <TextP font={fonts.font1.H11}>{searchCount} results (</TextP>
        <Button
          onClick={() => {
            setSearchValue('');
            handleSearch('CLEAR');
          }}
          theme="plainSecondary"
        >
          <TextP font={fonts.font1.H11}>{total} total</TextP>
        </Button>
        <TextP font={fonts.font1.H11}>)</TextP>
      </Styled.TextWrapper>
    )}
  </Styled.SearchBarStyled>
);

export default SearchBar;
